<template>
  <div class="carousel">
    <div class="view1">
      <CommonSwiper
        ref="swiper"
        :options="options"
        @ready="
          swiper = $event
          reportShow()
        "
        @SlideChangeEnd="
          chagned($event)
          reportShow()
        "
        @SlideClick="reportClick"
      >
        <div class="swiper-wrapper">
          <div
            v-for="(item, i) in list"
            :key="i"
            class="swiper-slide"
            style="position: relative"
          >
            <a href="javascript:;" @click="$util.jumpUrl(item.jump_url)">
              <img v-lazy="item.img_url" />
            </a>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </CommonSwiper>
    </div>
    <div class="preview1">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="(item, i) in list"
            :key="i"
            class="swiper-slide"
            @click="swiperTo(i)"
          >
            <img v-lazy="item.img_url" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      options: {
        mode: 'vertical',
        speed: 1000
      },
      cur: 0
    }
  },
  methods: {
    reportShow() {
      this.$xlaGamePush('home_banner_content_show', {
        game_id: this.$route.params.game_id
      })
    },
    reportClick() {
      this.$xlaGamePush('home_banner_content_click', {
        game_id: this.$route.params.game_id,
        rn: this.swiper.activeIndex
      })
    },
    swiperTo(index) {
      this.swiper.swipeTo(index)
    },
    chagned(swiper) {
      this.cur = swiper.activeIndex
    }
  }
}
</script>
